export const blockIconsAndroidAirplanemodeActiveNew = (
	<span className='material-symbols-outlined'>airplanemode_active</span>
);
